<template>
  <teleport to="body">
    <div class="ui-kk-toast-provider">
      <transition-group name="ui-kk-toast__transition">
        <kk-toast
          v-for="(item, index) in messages"
          v-bind="item"
          :key="item.key"
          :style="{top: 132 + index * 70 + 'px'}"
        >
          {{ item.content }}
        </kk-toast>
      </transition-group>
    </div>
  </teleport>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import KkToast from './kk-toast.vue';
import { KKToastInnerProps } from './typings';

export default defineComponent({
  name: 'KkToastProvider',
  components: {
    KkToast,
  },
  inheritAttrs: false,
  props: {
    messages: {
      type: Array as PropType<KKToastInnerProps[]>,
      default: () => [],
    },
  },
});

</script>

<style lang="scss" src="./style.scss"></style>
